var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-map-marker',{attrs:{"lat-lng":[_vm.location.lat, _vm.location.lng],"point":_vm.point,"isMeta":_vm.isMeta,"disabled":!_vm.isSelectedClassificationMarker},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_vm._l((_vm.types),function(type,typeName){
var _obj;
return [(_vm.hasType(type))?_c('div',{key:type,class:( _obj = {
                    icon: true
                }, _obj[("icon--" + typeName)] = true, _obj.disabled = _vm.hasType(type) &&
                        !_vm.hasSelectedClassification(type), _obj )}):_vm._e()]}),_c('div',{class:_vm.pointerClasses})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }